import { Button, Modal, Text } from "@marketplace/ui";
import { notifications } from "@marketplace/ui/notifications";
import { useAtomValue } from "jotai";
import { useResetAtom } from "jotai/utils";
import { useTranslation } from "react-i18next";

import { deleteProductPackageModalAtom } from "../../atoms/product-detail-page-atom";
import { useDeleteProductPackageMutation } from "../../hooks/mutations/use-delete-product-package-mutation";

export const DeletePackageModal = () => {
  const { t: tProduct } = useTranslation("product");
  const { t: tCommon } = useTranslation("common");
  const { visible, data } = useAtomValue(deleteProductPackageModalAtom);
  const resetDeleteProductModal = useResetAtom(deleteProductPackageModalAtom);

  const { mutateAsync: mutateDeleteProductPackage, isPending } =
    useDeleteProductPackageMutation();

  const handleDelete = async () => {
    try {
      if (!data?.packageId) return;

      await mutateDeleteProductPackage({
        packageId: data.packageId
      });

      notifications.show({
        message: tProduct("notifications.successDeleteProductPackage")
      });
      resetDeleteProductModal();
    } catch {
      notifications.show({
        variant: "error",
        message: tProduct("notifications.faieldToDeleteProductPackage")
      });
    }
  };

  return (
    <Modal.Root opened={visible} onClose={resetDeleteProductModal} size={334}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Body classNames={{ body: "!p-[42px]" }}>
          <Text type="paragraph" className="text-center mb-6">
            {tProduct("modal.deletePackageModal.description", {
              packageName: data?.packageName
            })}
          </Text>
          <div className="flex gap-x-[14px]">
            <Button
              variant="secondary"
              fullWidth
              onClick={resetDeleteProductModal}
            >
              {tCommon("no")}
            </Button>
            <Button
              variant="primary"
              fullWidth
              loading={isPending}
              onClick={handleDelete}
            >
              {tCommon("yes")}
            </Button>
          </div>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
